module.exports = __webpack_public_path__ + "img/09.2996a3db.png";